<template>
  <div class="pageContent">
    <div class="pageContent__card">
      <div class="pageContent__container">
        <div class="pageContent__header">
          <gl-svg-icon :name="iconName" class="pageContent__logo" />
          <h1 class="pageContent__title">{{ title }}</h1>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import GlSvgIcon from '@gl/GlSvgIcon'

export default {
  name: 'GlPage',
  components: { GlSvgIcon },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.pageContent {
  background: linear-gradient(180deg, rgba(50, 61, 66, 0.85) -7.13%, rgba(18, 18, 18, 0.85) 100%),
    url('../assets/img/bg-sm.jpg') center top repeat-y;
  display: flex;
  padding: 24px 16px;

  @media (min-width: $breakpoint-md) {
    background-image: linear-gradient(
        180deg,
        rgba(50, 61, 66, 0.85) -7.13%,
        rgba(18, 18, 18, 0.85) 100%
      ),
      url('../assets/img/bg.jpg');
    background-size: 100% auto;
  }

  &__card {
    background: rgba(18, 18, 18, 0.38);
    padding: 32px 16px;
    width: 100%;

    @media (min-width: $breakpoint-lg) {
      padding: 32px;
    }
  }

  &__container {
    @media (min-width: $breakpoint-xl) {
      margin: 0 auto;
      max-width: 1540px;
    }
  }

  &__header {
    display: flex;
    margin-bottom: 32px;

    @media (min-width: $breakpoint-xl) {
      align-items: center;
    }
  }

  &__logo {
    margin-right: 16px;

    @media (min-width: $breakpoint-md) {
      height: 32px;
      width: 32px;
    }

    @media (min-width: $breakpoint-xl) {
      height: 48px;
      margin-right: 12px;
      width: 48px;
    }
  }

  &__title {
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-transform: uppercase;

    @media (min-width: $breakpoint-md) {
      font-size: 24px;
      line-height: 32px;
    }

    @media (min-width: $breakpoint-xl) {
      font-size: 32px;
      line-height: 40px;
    }
  }
}
</style>
